import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import Icon from 'assets/components/icon/Icon';
import CheckInput from 'assets/components/inputs/check/CheckInput';
import DateInput from 'assets/components/inputs/dateInput/DateInput';
import { inputStyles } from 'assets/components/inputs/Input';
import MultilineTextInput from 'assets/components/inputs/multilineText/MultilineTextInput';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { defaultInputDateFormat } from 'assets/utils/data/Date';
import ContractCancellationReasons from 'models/enums/ContractCancellationReasons';
import { ContractRefundProcessForm } from '../Contract.RefundProcess';

const ContractRefundProcessDetails = () => {
  const { form } = useModalForm<ContractRefundProcessForm>();
  const { lang } = getLocales();
  return (
    <FormWrapper>
      <DateInput
        name="cancellationDateLocal"
        label={lang.cancellationDate}
        dateTimeFormat={defaultInputDateFormat}
        isLocal={true}
        value={form?.data?.cancellationDateLocal}
        error={form?.errors?.cancellationDateLocal}
        // max={dayjs().format(defaultServerDateFormat)} //TODO: Uncomment!
        onChange={form.update}
        icon={<Icon class="fas-calendar-alt" />}
      />
      <SelectInput
        name="reason"
        label={lang.cancellationReason}
        value={form?.data?.reason}
        error={form?.errors?.reason}
        data={Object.values(ContractCancellationReasons).map((id) => ({
          id,
          title: id,
        }))}
        onChange={form.update}
      />
      {form.data?.reason === ContractCancellationReasons.OTHER && (
        <MultilineTextInput
          name="reasonDescription"
          label={lang.cancellationReasonDescription}
          value={form?.data?.reasonDescription}
          error={form?.errors?.reasonDescription}
          onChange={form.update}
        />
      )}
      <NumberInput
        name="odometerReading"
        label={lang.odometerReading}
        value={form?.data?.odometerReading}
        error={form?.errors?.odometerReading}
        onChange={form.update}
      />
      <hr />
      <CheckInput
        name="isLoyaltyPremiumApplied"
        label={lang.loyaltyPremiumApplies}
        class={inputStyles.check.switch}
        value={form.data.isLoyaltyPremiumApplied}
        onChange={form.update}
        htmlElementProps={{ title: form.data.isLoyaltyPremiumApplied ? lang.disable : lang.enable }}
      />
      {form.data.isLoyaltyPremiumApplied && (
        <TextInput
          name="newAppNumber"
          label={lang.newAppNumber}
          value={form?.data?.newAppNumber}
          error={form?.errors?.newAppNumber}
          onChange={form.update}
        />
      )}
      <CheckInput
        name="areClaimDeductionsApplied"
        label={lang.claimDeductionsApply}
        class={inputStyles.check.switch}
        value={form.data.areClaimDeductionsApplied}
        onChange={form.update}
        htmlElementProps={{ title: form.data.areClaimDeductionsApplied ? lang.disable : lang.enable }}
      />
    </FormWrapper>
  );
};

export default ContractRefundProcessDetails;
